<!-- PAGE HEADER -->
<div class="page-header">
  <h2>User Profile</h2>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium" color="#ffffff" type="ball-spin-clockwise" [fullScreen]="true">
</ngx-spinner>

<!-- FORM CARD -->
<div class="container">

  <form [formGroup]="profileForm" (ngSubmit)="submit()">

    <p class="required-note"><span>*</span> Required</p>

    <div class="row name-job-row">
      <div class="field">
        <label>Prefix</label>
        <select formControlName="prefix">
          <option value="">Select</option>
          <option *ngFor="let prefix of prefixList" [value]="prefix.prefixPk">
            {{ prefix.prefix }}
          </option>
        </select>
      </div>

      <div class="field" [ngClass]="displayFieldCss('profileForm.firstName')">
        <label><span>* </span>First Name </label>
        <input type="text" formControlName="firstName" maxlength="100">
        <div class="error-message"
          *ngIf="profileForm | invalidChars:'firstName':ValidationPatterns.ALLOWED_NAME_CHARS as invalidChars">
          Invalid chars: {{ invalidChars }}
        </div>
      </div>

      <div class="field" [ngClass]="displayFieldCss('profileForm.lastName')">
        <label><span>* </span>Last Name</label>
        <input type="text" formControlName="lastName" maxlength="100">
        <div class="error-message"
          *ngIf="profileForm | invalidChars:'lastName':ValidationPatterns.ALLOWED_NAME_CHARS as invalidChars">
          Invalid chars: {{ invalidChars }}
        </div>
      </div>

      <div class="field">
        <label>Suffix</label>
        <select formControlName="suffix">
          <option value="">Select</option>
          <option *ngFor="let suffix of suffixList" [value]="suffix.suffixPk">
            {{ suffix.suffix }}
          </option>
        </select>
      </div>

      <div class="field">
        <label>Job Title</label>
        <input type="text" formControlName="jobTitle" maxlength="100">
        <div class="error-message"
          *ngIf="profileForm | invalidChars:'jobTitle':ValidationPatterns.ALLOWED_JOB_CHARS as invalidChars">
          Invalid chars: {{ invalidChars }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="ext-fax-group">
        <div class="field fax-field" [ngClass]="displayFieldCss('profileForm.phone')">
          <label><span>* </span>Phone </label>
          <input type="text" formControlName="phone" mask="(000) 000-0000" [validation]="true"
            [dropSpecialCharacters]="true" placeholder="(XXX) XXX-XXXX" />
        </div>

        <div class="field ext-field">
          <label>Ext</label>
          <input type="text" inputmode="numeric" formControlName="phoneExt" maxlength="10"
            (input)="allowNumbersOnly($event, 'phoneExt')" />
        </div>
      </div>
      <div class="field">
        <label>Fax</label>
        <input type="text" formControlName="fax" mask="(000) 000-0000" [validation]="true"
          [dropSpecialCharacters]="true" placeholder="(XXX) XXX-XXXX" />
      </div>


      <div class="field" [ngClass]="displayFieldCss('profileForm.email')">
        <label><span>* </span>Email</label>
        <input type="email" [disabled]="pageMode === 'Edit'" formControlName="email" maxlength="100"
          pattern="^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$" />
        <div class="error-message"
          *ngIf="profileForm | invalidChars:'email':ValidationPatterns.ALLOWED_EMAIL_CHARS as invalidChars">
          Invalid chars: {{ invalidChars }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="field">
        <label><span>* </span>Role</label>
        <select formControlName="roleCode">
          <option value="">Select</option>
          <option *ngFor="let role of roleList" [value]="role.id">
            {{ role.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="actions mt-30">
      <button type="button" (click)="cancel()">Close</button>
      <button *ngIf="pageMode === 'Edit' || pageMode === 'Add'" type="submit">Save</button>
    </div>
  </form>

</div>

<p-dialog header="{{ dialogSummary }}"
  [styleClass]="dialogSummary === 'Success' ? 'success-dialog' : 'success-dialog error'" [(visible)]="locListModalDlg"
  [closable]="false" [closeOnEscape]="false" [modal]="true" [dismissableMask]="false" [style]="{ width: '580px' }"
  [breakpoints]="{ '640px': '95vw' }">

  <div class="dialog-body" [innerHTML]="dialogMsg"></div>

  <ng-template pTemplate="footer">
    <div class="actions">

      <!-- UNSAVED CHANGES BUTTONS -->
      <ng-container *ngIf="dialogType === 'unsaved'">
        <button type="button" class="button-primary" (click)="stayOnPage()">
          Continue Editing
        </button>

        <button type="button" class="button-primary" (click)="leavePage()">
          Leave
        </button>
      </ng-container>

      <!-- SUCCESS / ERROR BUTTON -->
      <ng-container *ngIf="dialogType !== 'unsaved'">
        <button type="button" class="button-primary" (click)="okClickedV2()">
          Ok
        </button>
      </ng-container>

    </div>
  </ng-template>
</p-dialog>